'use strict';
var formValidation = require('base/components/formValidation');

/**
 * appends params to a url
 * @param {string} data - data returned from the server's ajax call
 * @param {Object} button - button that was clicked to add a product to the wishlist
 */
function displayMessage(data, button) {
    $.spinner().stop();
    var status;
    if (data.success) {
        status = 'alert-success';
    } else {
        status = 'alert-danger';
    }

    console.log(data);
    if ($('.add-giftcert-to-basket-messages').length === 0) {
        $('body').append(
        '<div class="add-giftcert-to-basket-messages "></div>'
        );
    }
    $('.add-giftcert-to-basket-messages')
        .append('<div class="add-giftcert-to-basket-alert text-center ' + status + '">' + data.msg + '</div>');

    setTimeout(function () {
        $('.add-giftcert-to-basket-messages').remove();
        button.removeAttr('disabled');
    }, 5000);
}
function showGiftCertBalance(button) {
    var url = button.data('href');
    var $form = button.parents('form:first');
    var code = $form.find('#code');
    var balance = $form.find('#balance');

    if (!url) {
        return;
    }
    if(code.length > 0 && code.val()) {
        url = (url.indexOf('?') === -1) ? url + '?' : url + '&';
        url += "gift_code="+code.val();
    }

    $.spinner().start();
    $(this).attr('disabled', true);
    $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: $form.serialize(),
        success: function (data) {
            formValidation($form, data);
            $('form.giftcert-balance-form').trigger('giftcert-balance-form:error', data);
            $.spinner().stop();
            // displayMessage(data, button);
            // console.log("success");
            if(balance.length > 0) {balance.val(data.balance)}
        },
        error: function (err) {
            // displayMessage(err, button);
            $.spinner().stop();
            if(balance.length > 0) {balance.val("")}
        }
    });
}

function PreRedeemGiftButton(button) {
    var url = button.data('href');
    var $form = button.parents('form:first');
    var code = $form.find('#code');

    if (!url) {
        return;
    }
    if(code.length > 0 && code.val()) {
        url = (url.indexOf('?') === -1) ? url + '?' : url + '&';
        url += "gift_code="+code.val();
    }

    $.spinner().start();
    $(this).attr('disabled', true);
    $.ajax({
        url: url,
        type: 'post',
        dataType: 'json',
        data: $form.serialize(),
        success: function (data) {
            $.spinner().stop();
            if (data.error || !data.success){
                $('.gift-cert-success').hide()
                if(data.errorMsg){
                    $('.gift-cert-error').html(data.errorMsg);
                }
                $('.gift-cert-error').show()
                return;
            }
            formValidation($form, data);
            $('.is-santander').remove()
            if (data.giftCardInFull){
                disableOtherPaymentTypes();
            }
            $('.hide-gift-cert-total').removeClass('hide-gift-cert-total')
            $('.gift-cert-total-sum').text("- " + data.giftCardAttr.total)
            $('.grand-total-sum').text(data.giftCardAttr.grandTotal)
            $('#gift-cert-used').text(data.giftCardAttr.used)
            $('#gift-cert-balance').text(data.giftCardAttr.balance)
            $('#gift-cert-left').text(data.giftCardAttr.left)
            $('.gift-cert-success').show()
            $('.gift-cert-error').hide()
        },
        error: function (err) {
            $.spinner().stop();
            $('.gift-cert-success').hide()
            $('.gift-cert-error').show()
        }
    });
}

function disableOtherPaymentTypes(){
    $('#selectedPaymentOption').val('GIFT_CERTIFICATE')
    // disable other payment types
    $('[data-method-id="AdyenPOS"]').attr('disabled','disabled').addClass('fuldGiftCardPayment').find('.active').removeClass('.active');
    $('[data-method-id="AdyenComponent"]').attr('disabled','disabled').addClass('fuldGiftCardPayment').find('.additionalFields').hide()
    $('[data-method-id="Santander"]').attr('disabled','disabled').addClass('fuldGiftCardPayment').find('.active').removeClass('.active');
    $('[data-method-id="Basic_Invoice"]').attr('disabled','disabled').addClass('fuldGiftCardPayment').find('.active').removeClass('.active');
    $('.payment-option-list input:checked').prop('checked', false); 
    $('.paymentHeader').addClass('dimmed');
}

module.exports = {
    addToGiftCertToBasket: function () {
        	$('form.giftcert-purchase-form').submit(function (e) {
            e.preventDefault();
            var url = $(this).data('href');
            var $form = $(this);
            var button = $('.add_giftcert-to-basket');

            if (!url) {
                return;
            }

            $.spinner().start();
            $(this).attr('disabled', true);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: $form.serialize(),
                success: function (data) {
                	formValidation($form, data);
                	$('form.giftcert-purchase-form').trigger('.giftcert-purchase-form:error', data);
                    displayMessage(data, button);
                    $('.minicart').trigger('count:update', data);
                },
                error: function (err) {
                    displayMessage(err, button);
                }
            });
        });
    },
    checkGiftCertBalance: function () {
    	$('#CheckBalanceButton').click(function (e) {
            e.preventDefault();
            showGiftCertBalance($(this));
        });
    },
    preRedeemGiftButton: function () {
    	$('#PreRedeemGiftButton').click(function (e) {
            e.preventDefault();
            PreRedeemGiftButton($(this));
        });
    },

    giftCertInFull: function(){
        var giftCertInFull = $('#giftCertInFull');
        if(giftCertInFull.val() == "true"){
            disableOtherPaymentTypes();
        }
    }
};
